<!--
 * @LastEditors: zhanglinju
-->
<template>
  <div>
    <!-- 头部标题 -->
    <div class="listHead">
      <div>
        <div class="sCircle" />
        <span style="font-size: 16px; font-weight: 700">网页轮播图</span>
      </div>
      <div>
        <el-button
          v-if="webTemplate != 'WEB-004'"
          class="plainBtn cancel-button"
          size="small"
          @click="addItem(true)"
        >
          添加
        </el-button>
      </div>
    </div>
    <!-- 内容模块 -->
    <div
      v-if="webTemplate == 'WEB-004'"
      class="catalog-title"
    >
      <span class="catalog-name">首页</span>
      <el-button
        class="plainBtn cancel-button"
        style="margin-left: 20px"
        size="small"
        @click="addItem(true)"
      >
        添加
      </el-button>
    </div>
    <div class="data_body">
      <div
        v-for="(item, index) in list"
        :key="index"
        class="data_item"
        @click="setCarousel(item, true)"
      >
        <img
          :src="item.image"
          alt=""
        >
        <div
          v-if="item.status === 0"
          class="disableStatus"
        >
          <span>已禁用</span>
        </div>
      </div>
      <div
        v-show="list.length < 1"
        style="width: 100%; text-align: center; color: #aaa"
      >
        <img src="../../../../assets/image/no_data.png">
      </div>
    </div>
    <!-- 分页模块 -->
    <el-pagination
      v-show="pagination.total > 0 && webTemplate !== 'WEB-004'"
      background
      :page-sizes="pageSizes"
      :page-size.sync="pagination.size"
      layout="total, sizes, prev, pager, next, jumper"
      :current-page.sync="pagination.current"
      :total="pagination.total"
      @current-change="init"
      @size-change="sizeChange"
    />
    <template v-if="webTemplate =='WEB-004'">
      <div
        v-for="item in rotationCatalogList"
        :key="item.catalogId"
        class="data_body-container"
      >
        <div class="catalog-title">
          <span class="catalog-name">{{ item.name }}</span>
          <div style="display: flex; align-items: center">
            <el-radio-group
              v-model="item.rotation"
              @change="onRotationChange(item)"
            >
              <el-radio :label="0">
                不用轮播
              </el-radio>
              <el-radio :label="1">
                共用首页
              </el-radio>
              <el-radio :label="2">
                自定义
              </el-radio>
            </el-radio-group>
            <el-button
              :disabled="item.rotation != 2"
              class="plainBtn cancel-button"
              style="margin-left: 20px"
              size="small"
              @click="addItem(false, item)"
            >
              添加
            </el-button>
          </div>
        </div>
        <div
          v-if="item.rotation != 0"
          class="data_body"
        >
          <div
            v-for="itm in item.rotation == 2 ? item.rotationList : list"
            :key="itm.id"
            :class="['data_item', item.rotation == 1 && 'un-editable']"
            @click="() => item.rotation != 1 && setCarousel(itm, false)"
          >
            <img
              :src="itm.image"
              alt=""
            >
            <div
              v-if="itm.status === 0"
              class="disableStatus"
            >
              <span>已禁用</span>
            </div>
          </div>
        </div>
        <div
          v-if="item.rotation == 1 ? list.length == 0 : (item.rotationList.length < 1 || item.rotation == 0)"
          style="width: 100%; text-align: center; color: #aaa; background-color: #FAFAFA"
        >
          <img src="../../../../assets/image/no_data.png">
        </div>
      </div>
    </template>
    <!-- 弹窗模块 -->
    <mix-dialog
      :modal="true"
      width="560px"
      class="right-dialog"
      :visible.sync="showDia"
    >
      <div
        slot="title"
        class="dialog-title"
      >
        <span>{{ titleName }}</span>
      </div>
      <div
        v-loading="loading"
        class="formBody"
      >
        <div>
          <div class="flex_row flex_center flex_mg">
            <div class="row_left">
              <span class="red_text">*</span>
              <span>轮播图</span>
            </div>
            <div class="miniImg">
              <div
                id="upimg"
                class="flex_column"
              >
                <yxp-upload
                  v-show="!setData.image && !loading"
                  ref="yxpupload"
                  uploader-id="uploadId"
                  :limit="1"
                  :max-size="51200"
                  :accept="acceptType"
                  :file-list="uplist"
                  upload-url="/res-file/upload/"
                  upload-mode-type="resource/wangyeguanli"
                  btn-name=""
                  class-name="cover-button"
                  :show-list="false"
                  :auto-upload="true"
                  @onChange="onChange"
                  @onFail="onFail"
                  @onSucc="onSucc"
                />
                <!-- <upload-img
                :userid="cpUserId"
                :placeholder="'static/layout/icon_default_school_pray.png'"
                :max-size="5120"
                :src="setData.image"
                @upload-success="uploadSuccess"
              /> -->
              </div>
              <span
                v-if="setData.image"
                class="image-wrapper"
                @click="imgdetail('img')"
              >
                <img :src="setData.image">
                <i
                  class="el-icon-error"
                  @click.stop="deleteImage"
                />
              </span>
              <!-- <p
                class="green"
              >
                建议轮播图长宽：750px*340px
              </p> -->
            </div>
          </div>
          <div
            class="flex_mg flex_center"
            style="margin-left: 86px"
          >
            <span style="margin-right: 30px">跳转</span>
            <el-radio-group v-model="radio">
              <el-radio :label="0">
                内容
              </el-radio>
              <el-radio :label="1">
                链接
              </el-radio>
              <el-radio :label="2">
                视频
              </el-radio>
            </el-radio-group>
          </div>
        </div>
        <div
          v-show="radio == 0"
          class="flex_row flex_center flex_mg"
        >
          <div class="row_left">
            <span>跳转内容</span>
          </div>
          <div
            id="pointer"
            class="row_right"
            @click="showManageDl"
          >
            <el-input
              v-model="manageList"
              placeholder="请选择跳转的内容页"
              disabled
            />
          </div>
        </div>

        <div
          v-show="radio == 1"
          class="flex_row flex_center flex_mg"
        >
          <div class="row_left">
            <span>跳转链接</span>
          </div>
          <div class="row_right">
            <el-input
              v-model="dataUrl"
              placeholder="请输入轮播图链接地址，以http或https开头"
              @blur="checkUrl"
            />
          </div>
        </div>

        <div
          v-show="radio == 2"
          class="flex_row flex_center flex_mg"
        >
          <div class="row_left">
            <span>播放视频</span>
          </div>
          <div
            id="upvideo"
            class="row_right upLod"
          >
            <div class="media-wrapper">
              <div class="video-wrapper">
                <!-- <div class="upload-title">
                  上传视频
                </div> -->
                <span
                  v-if="setData.video"
                  class="image-wrapper"
                  @click="imgdetail('video')"
                >
                  <i
                    class="el-icon-error"
                    @click.stop="deleteVedioInfo('contentVideo')"
                  />
                </span>
                <span
                  v-if="loading"
                  class="loading-wrapper"
                >上传中</span>
                <yxp-upload
                  v-show="!setData.video && !loading"
                  ref="yxpupload"
                  uploader-id="uploadId"
                  :limit="1"
                  :max-size="512000"
                  :accept="acceptVideoType"
                  :file-list="videoList"
                  upload-url="/res-file/upload/"
                  upload-mode-type="resource/wangyeguanli"
                  class-name="cover-button"
                  btn-name=""
                  :show-list="false"
                  :auto-upload="true"
                  @onProgress="onProgress"
                  @onChange="onVideoChange"
                  @onFail="onVideoFail"
                  @onSucc="VideoOnSucc"
                />
                <!-- <div class="video-name">
                  {{ videoName }}
                </div> -->
              </div>
            </div>
          </div>
        </div>
        <div
          v-if="radio === 1 && showerr"
          class="errtst"
        >
          <span>请输入合法的链接</span>
        </div>
        <div class="flex_row flex_center flex_mg">
          <div class="row_left">
            <span class="red_text">*</span>
            <span>排序</span>
          </div>
          <div class="row_right">
            <el-select
              v-model="ImgoptionValue"
              placeholder="请选择"
              style="width: 360px"
            >
              <el-option
                v-for="(item, index) in arr"
                :key="index"
                :label="index + 1"
                :value="index + 1"
              />
            </el-select>
          </div>
        </div>
        <div class="flex_row flex_center flex_mg">
          <div class="row_left">
            <span class="red_text">*</span>
            <span>适用</span>
          </div>
          <div class="row_right">
            <el-select
              v-model="clientType"
              placeholder="请选择"
              style="width: 360px"
            >
              <el-option
                v-for="(item) in clientList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </div>
        </div>
      </div>
      <div class="add-match">
        <transition name="el-zoom-in-bottom">
          <div class="btn-box-fixed">
            <el-button
              v-show="!isNew && setData.status == 1"
              size="medium"
              class="plainBtn disable-button"
              @click="updateStatusRotation()"
            >
              禁用
            </el-button>
            <el-button
              v-show="!isNew && setData.status == 0"
              size="medium"
              class="plainBtn disable-button"
              @click="updateStatusRotation()"
            >
              启用
            </el-button>
            <el-button
              v-show="!isNew"
              size="medium"
              class="plainBtn dilite-button"
              @click="deleteRotation()"
            >
              删除
            </el-button>
            <el-button
              size="medium"
              class="plainBtn cancel-button"
              plain
              @click="showDia = false"
            >
              取消
            </el-button>
            <el-button
              size="medium"
              type="primary"
              @click="setRotation()"
            >
              确认
            </el-button>
          </div>
        </transition>
      </div>
    </mix-dialog>

    <mix-dialog
      :modal="true"
      width="800px"
      :visible.sync="showManage"
    >
      <div
        slot="title"
        class="dialog-title"
      >
        <span>跳转内容</span>
      </div>
      <div class="formBody">
        <div class="result">
          <span>{{ acvtiveRedio }}</span>
        </div>
        <div class="iptDiv">
          <el-input
            v-model="seachValue"
            placeholder="请输入内容名称或关键字查询"
            prefix-icon="el-icon-search"
          />
        </div>
        <div class="tree_btm">
          <div class="left_contente">
            <el-tree
              ref="tree"
              :data="treeData"
              :props="defaultProps"
              :highlight-current="true"
              node-key="catalogId"
              :current-node-key="currentNode"
              @node-click="handleNodeClick"
            >
              <span
                slot-scope="{ node, data }"
                class="custom-tree-node"
              >
                <span>{{ data[defaultProps.label] }}</span>
                <span class="icon-wrap">
                  <i
                    class="icon_detail"
                    @click.stop="editNode(node, data, 'emit')"
                  />
                  <i
                    class="icon_add"
                    @click.stop="addChildNode(node, data, 'emit')"
                  />
                  <i
                    v-if="data.status == 1"
                    class="icon_disable"
                    @click.stop="changeNodeStatus(node, data)"
                  />
                  <i
                    v-else
                    class="icon_enable"
                    @click.stop="changeNodeStatus(node, data)"
                  />
                  <i
                    v-if="showBtn(node, data, 'up')"
                    class="icon_up"
                    @click.stop="nodeUp(node, data, 'emit')"
                  />
                  <i
                    v-if="showBtn(node, data, 'down')"
                    class="icon_down"
                    @click.stop="nodeDown(node, data, 'emit')"
                  />
                </span>
              </span>
            </el-tree>
          </div>
          <div class="right_contente">
            <el-radio-group
              v-model="PageListRadio"
              class="lin_radio"
            >
              <el-radio
                v-for="(items, indexs) in PageList"
                :key="indexs"
                :label="indexs"
                @change="checkRadio"
              >
                {{ items.title }}
              </el-radio>
            </el-radio-group>
          </div>
        </div>
      </div>

      <div class="add-match">
        <transition name="el-zoom-in-bottom">
          <div class="btns">
            <el-button
              class="plainBtn"
              size="medium"
              @click="showManage = false"
            >
              取消
            </el-button>
            <el-button
              size="medium"
              type="primary"
              @click="submitManage"
            >
              确认
            </el-button>
          </div>
        </transition>
      </div>
    </mix-dialog>
    <el-dialog
      :visible.sync="showVideoDialog"
      width="50%"
    >
      <div
        slot="title"
        class="dialog-title"
      >
        <span>{{ dialogtitle }}</span>
      </div>
      <video
        v-show="dialogimg == null"
        style="width: 100%"
        controls
        autoplay
      >
        <source
          :src="videoUrl"
          type="video/mp4"
        >
      </video>
      <div
        v-if="dialogimg !== null"
        class="dialogimgdiv"
      >
        <img
          :src="dialogimg"
          alt=""
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { pageSizes } from '@/lib/utils';
import api from './proxy';
export default {
    data () {
        return {
            pagination: {
                total: 1,
                current: 1,
                size: 10,
            },
            webTemplate: '',
            showerr: false,
            titleName: '修改主页轮播图',
            radio: 0,
            optionValue: '',
            ImgoptionValue: '',
            clientType: 0, // 0 全部; 1 web; 2 h5
            clientList: [{
                label: '全部',
                value: 0,
            }, {
                label: 'web',
                value: 1,
            }, {
                label: 'h5',
                value: 2,
            }],
            dataUrl: '',
            showDia: false,
            list: [],
            rotationCatalogList: [],
            isHome: true,
            uplist: [],
            videoList: [],
            videoName: '',
            acceptType: '.jpg,.jpeg,.png',
            acceptVideoType: '.mp4',
            loading: false,
            isNew: false, // 是否为新增轮播图
            setData: {},
            newList: null,
            manageList: '',
            pageSizes,
            seachValue: '',
            showManage: false,
            treeData: [],
            currentNode: null,
            PageList: [],
            PageListRadio: null,
            acvtiveRedio: '',
            defaultProps: {
                children: 'children',
                label: 'name',
            },
            videoUrl: null,
            showVideoDialog: false,
            dialogtitle: '播放视频', // 弹窗名称
            dialogimg: null, // 弹窗图片
        };
    },
    computed: {
        cpUserId () {
            return this.$store.state.global.loginInfo.userId;
        },
    },
    watch: {
        seachValue (newVal) {
            this.getPageList('', newVal);
        },
    },
    created () {
        this.webTemplate = this.$route.query.webTemplate;
        this.getRotationList();
        let arr = [];
        for (let index = 1; index < 100; index++) {
            arr.push(index);
        }
        this.arr = arr;
        if (this.webTemplate === 'WEB-004') {
            this.getRotationCatalogList();
        }
    },
    methods: {
        init (e) {
            this.pagination.current = e;
            this.getRotationList();
        },
        checkUrl () {
            // console.log(this.isURL(this.dataUrl));
            this.showerr = !this.isURL(this.dataUrl);
        },
        isURL (url) {
            if (!url) return false;
            const strRegex =
                '^((https|http|ftp)://)?' + // (https或http或ftp):// 可有可无
                "(([\\w_!~*'()\\.&=+$%-]+: )?[\\w_!~*'()\\.&=+$%-]+@)?" + // ftp的user@ 可有可无
                '(([0-9]{1,3}\\.){3}[0-9]{1,3}' + // IP形式的URL- 3位数字.3位数字.3位数字.3位数字
                '|' + // 允许IP和DOMAIN（域名）
                '(localhost)|' + // 匹配localhost
                "([\\w_!~*'()-]+\\.)*" + // 域名- 至少一个[英文或数字_!~*\'()-]加上.
                '\\w+\\.' + // 一级域名 -英文或数字 加上.
                '[a-zA-Z]{1,6})' + // 顶级域名- 1-6位英文
                '(:[0-9]{1,5})?' + // 端口- :80 ,1-5位数字
                // '((/?)|' + // a slash isn't required if there is no file name
                // "(/[0-9a-z_!~*'().;?:@&=+$,%#-]+)+/?)$";
                '';
            const re = new RegExp(strRegex, 'i'); // 大小写不敏感
            if (re.test(encodeURI(url))) {
                return true;
            }
            return false;
        },
        checkLink (value) {
            if (!value) return true;
            let reg = /(https?|ftp|file):\/\/[-A-Za-z0-9+&@#/%?=~_|!:,.;]+[-A-Za-z0-9+&@#/%=~_|]/;
            let re = new RegExp(reg);
            return re.test(value);
        },
        sizeChange (p) {
            this.pagination.size = p;
            this.init();
        },
        preview () {
            this.$router.push({ name: 'mobileModules' });
        },
        imgdetail (type) {
            if (type === 'img') {
                this.showVideoDialog = true;
                this.dialogtitle = '轮播图';
                this.dialogimg = this.setData.image;
            } else {
                this.showVideoDialog = true;
                this.dialogtitle = '播放视频';
                this.dialogimg = null;
            }
        },
        showDetail () {},
        onRotationChange (item) {
            api.catalogrRotationSetting({ catalogId: item.catalogId, rotation: item.rotation }).then(res => {});
        },
        // 轮播图详情
        setCarousel (e, isHome) {
            this.titleName = '修改轮播图';
            this.showDia = true;
            this.isNew = false;
            this.showerr = false;
            this.isHome = isHome;
            this.dataUrl = e.link;
            this.radio = e.type;
            this.ImgoptionValue = e.rank;
            this.videoUrl = e.video;
            this.clientType = e.clientType;

            this.manageList = e.contentTitle;
            this.contentTitle = e.contentTitle;
            this.acvtiveRedio = e.contentTitle;
            this.acvtiveRedioId = e.contentId;
            // this.getPageList(e.contentId); // 获取跳转内容 名称
            this.newList = this.list;
            this.setData = JSON.parse(JSON.stringify(e));
        },
        // 轮播图列表
        getRotationList () {
            let params = {
                siteId:
          this.$route.query.siteId ||
          this.$store.getters['system/getSiteList'][0].siteId,
                pageNo: this.pagination.current,
                pageSize: this.webTemplate !== 'WEB-004' ? this.pagination.size : 999,
            };
            api.getRotationList(params).then(res => {
                if (res.errcode === 0) {
                    this.list = res.data.list;
                    this.pagination.total = res.data.totalCount;
                }
            });
        },
        getRotationCatalogList () {
            const siteId = this.$route.query.siteId || this.$store.getters['system/getSiteList'][0].siteId;
            api.getRotationCatalogList({ siteId }).then(res => {
                if (res.errcode === 0) {
                    this.rotationCatalogList = res.data;
                }
            });
        },

        // 新增轮播图
        addItem (isHome, item) {
            this.titleName = '添加轮播图';
            this.isHome = isHome;
            this.radio = 0;
            this.dataUrl = '';
            this.acvtiveRedioId = '';
            this.acvtiveRedio = '';
            this.manageList = '';
            // this.getparentList();
            this.setData = {
                siteId:
          this.$route.query.siteId ||
          this.$store.getters['system/getSiteList'][0].siteId,
                type: this.radio, // (0:内容 1:链接 2:视频)
                contentId: this.acvtiveRedioId,
                link: this.dataUrl,
                image: '',
                video: '',
                rank: '',
                catalogId: item ? item.catalogId : '',
            };

            this.newList = JSON.parse(JSON.stringify(this.list));
            this.newList.push({
                siteId:
          this.$route.query.siteId ||
          this.$store.getters['system/getSiteList'][0].siteId,
                type: this.radio, // (0:内容 1:链接 2:视频)
                contentId: this.acvtiveRedioId,
                link: this.dataUrl,
                image: '',
                video: '',
                rank: 1,
            });
            this.ImgoptionValue = 1;
            this.isNew = true;
            this.showDia = true;
        },
        // 修改轮播图
        setRotation () {
            if (this.isNew) {
                this.addRotation();
            } else {
                let params = this.setData;
                params.type = this.radio;
                params.link = this.dataUrl;
                params.contentId = this.acvtiveRedioId;
                params.rank = this.ImgoptionValue;
                params.catalogId = this.setData.catalogId || '';
                params.clientType = this.clientType || 0;
                // let reg = /(https?|ftp|file):\/\/[-A-Za-z0-9+&@#/%?=~_|!:,.;]+[-A-Za-z0-9+&@#/%=~_|]/;
                // if (!reg.test(this.dataUrl)) {
                //     this.showerr = true;
                // } else if (this.setData.image) {
                if (this.radio === 1 && !this.isURL(this.dataUrl)) {
                    this.showerr = true;
                } else if (this.setData.image) {
                    // if (this.setData.image) {
                    const apiFun = this.isHome ? api.setRotation : api.catalogrRotationSave;
                    apiFun(params).then(res => {
                        if (res.errcode === 0) {
                            // this.list = res.data.list;
                            this.$message.success('修改成功');
                            this.showDia = false;
                            if (this.isHome) {
                                this.getRotationList();
                            } else {
                                this.getRotationCatalogList();
                            }
                        }
                    });
                } else {
                    this.$message.error('请上传轮播图');
                }
            }
        },
        // 添加轮播图
        addRotation () {
            if (this.setData.image) {
                let params = this.setData;
                params.type = this.radio;
                params.link = this.dataUrl;
                params.rank = this.ImgoptionValue;
                params.contentId = this.acvtiveRedioId;
                params.catalogId = this.setData.catalogId || '';
                params.clientType = this.clientType || 0;
                console.log(this.setData);
                const apiFun = this.isHome ? api.addRotation : api.catalogrRotationSave;
                apiFun(params).then(res => {
                    if (res.errcode === 0) {
                        // this.list = res.data.list;
                        this.$message.success('添加成功');
                        this.showDia = false;
                        if (this.isHome) {
                            this.getRotationList();
                        } else {
                            this.getRotationCatalogList();
                        }
                    }
                });
            } else {
                this.$message.error('请上传轮播图');
            }
        },
        // 删除轮播图
        deleteRotation () {
            const apiFun = this.isHome ? api.deleteRotation : api.catalogrRotationDelete;
            apiFun({ id: this.setData.id }).then(res => {
                if (res.errcode === 0) {
                    // this.list = res.data.list;
                    this.$message.success('删除成功');
                    this.showDia = false;
                    if (this.isHome) {
                        this.getRotationList();
                    } else {
                        this.getRotationCatalogList();
                    }
                }
            });
        },
        // 显示选择内容弹窗
        showManageDl () {
            this.showManage = true;
            this.getTreeList();
            this.getPageList();
        },
        // 获取树状列表
        getTreeList () {
            let parmas = {
                isShowDisable: 1,
                siteId:
          this.$route.query.siteId ||
          this.$store.getters['system/getSiteList'][0].siteId,
            };
            api.getTreeList(parmas).then(res => {
                this.treeData = res.data.value.catalogList;
                console.log(this.treeData);
            });
        },
        showBtn (node, data, ty) {
            let parent = node.parent,
                children = parent.data.children || parent.data,
                idx = children.findIndex(itm => itm === data);
            return ty === 'up' ? idx !== 0 : idx !== children.length - 1;
        },
        handleNodeClick (node) {
            this.getPageList(node.catalogId);
        },
        // 选中内容事件
        checkRadio (e) {
            this.acvtiveRedio = this.PageList[e].title;
            this.acvtiveRedioId = this.PageList[e].contentId;
        },
        submitManage () {
            this.manageList = this.acvtiveRedio;
            this.showManage = false;
        },
        // 启用禁用轮播图
        updateStatusRotation () {
            console.log(this.setData.status);
            if (this.setData.status === 1) {
                this.$confirm('确认禁用？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning',
                })
                    .then(() => {
                        let parmas = {
                            id: this.setData.id,
                            status: 0,
                        };
                        const apiFun = this.isHome ? api.updateStatusRotation : api.catalogrRotationUpdate;
                        apiFun(parmas).then(res => {
                            if (res.errcode === 0) {
                                // this.list = res.data.list;
                                this.showDia = false;
                                if (this.isHome) {
                                    this.getRotationList();
                                } else {
                                    let isChange = false;
                                    for (const item of this.rotationCatalogList) {
                                        for (const itm of item.rotationList) {
                                            if (itm.id === this.setData.id) {
                                                itm.status = 0;
                                                isChange = true;
                                                break;
                                            }
                                        }
                                        if (isChange) break;
                                    }
                                }
                                this.$message.success('禁用成功');
                            }
                            console.log(res);
                        });
                    })
                    .catch(() => {});
            } else {
                let parmas = {
                    id: this.setData.id,
                    status: 1,
                };
                const apiFun = this.isHome ? api.updateStatusRotation : api.catalogrRotationUpdate;
                apiFun(parmas).then(res => {
                    if (res.errcode === 0) {
                        // this.list = res.data.list;
                        this.showDia = false;
                        if (this.isHome) {
                            this.getRotationList();
                        } else {
                            let isChange = false;
                            for (const item of this.rotationCatalogList) {
                                for (const itm of item.rotationList) {
                                    if (itm.id === this.setData.id) {
                                        itm.status = 1;
                                        isChange = true;
                                        break;
                                    }
                                }
                                if (isChange) break;
                            }
                        }
                        this.$message.success('启用成功');
                    }
                });
            }
        },

        getPageList (catalogId, keyWord) {
            let parmas = {
                siteId:
          this.$route.query.siteId ||
          this.$store.getters['system/getSiteList'][0].siteId,
                catalogId: catalogId,
                keyWord: keyWord,
                pageNo: 1,
                pageSize: 10,

            };
            api.getPageList(parmas).then(res => {
                this.PageList = res.data.list;
                // console.log(res);
            });
        },
        deleteVedioInfo (prop) {
            this.setData.video = '';
            this.videoName = '';
        },
        deleteImage () {
            this.setData.image = '';
        },
        onVideoChange (file) {
            this.loading = true;
        },
        onVideoFail (file) {
            this.loading = false;
        },
        onProgress (progress) {},
        // 上传成功
        onSucc (res, file) {
            this.loading = false;
            if (this.setData) {
                this.setData.image = res.url;
                this.uplist = [];
            }
        },
        uploadSuccess (p) {
            this.setData.image = p.fileUrl;
        },
        VideoOnSucc (res, file) {
            this.loading = false;
            if (this.setData) {
                this.setData.video = res.url;
                this.videoUrl = res.url;
                // this.videoName = res.rawFile.name;
                this.videoList = [];
            }
        },
        onChange (file) {
            this.loading = true;
        },
        onFail (file) {
            console.log('file: ', file);
        },
        handleExceedLimit () {
            this.$message.error('图片数量已超出，只允许上传1张！');
        },
    },
};
</script>

<style lang="scss">
#pointer {
  & /deep/ .el-input__inner {
    cursor: pointer;
  }
}
#upimg {
  .yxp-uploader {
    display: inline-block;
    .cover-button {
      width: 172px;
      height: 80px;
      border-radius: 4px;
      background: url("../../../../assets/icon/icon_plus.png") no-repeat center;
      background-color: #f2f4fc;
      background-size: 20px 20px;
      &:hover {
        background-color: #f2eefc;
      }
    }
  }
}

#upvideo {
  .yxp-uploader {
    display: inline-block;
    .cover-button {
      width: 124px;
      height: 80px;
      border-radius: 4px;
      background: url("../../../../assets/icon/icon_plus.png") no-repeat center;
      background-color: #f2f4fc;
      background-size: 20px 20px;
      &:hover {
        background-color: #f2eefc;
      }
    }
  }
  .media-wrapper {
    display: flex;
    .video-wrapper {
      width: 200px;
    }
    .upload-title {
      color: #505050;
    }
    .image-wrapper {
      position: relative;
      vertical-align: top;
      display: inline-block;
      width: 124px;
      height: 80px;
      border-radius: 4px;
      background: url("../../../../assets/icon/icon_play.png") no-repeat center;
      background-color: #f2f4fc;
      background-size: 20px 20px;
      cursor: pointer;
      i {
        position: absolute;
        top: -8px;
        right: -8px;
        z-index: 1;
        font-size: 18px;
        color: #999;
        cursor: pointer;
      }
    }
    .loading-wrapper {
      position: relative;
      vertical-align: top;
      display: inline-block;
      width: 124px;
      height: 80px;
      line-height: 80px;
      text-align: center;
      border-radius: 4px;
      background-color: #f2f4fc;
      color: #a0a0a0;
      cursor: progress;
    }
    .cover-wrapper {
      .image-wrapper {
        width: 124px;
      }
      img {
        max-width: 124px;
        height: 80px;
        border-radius: 4px;
      }
    }
  }
  .tip {
    color: #f3864b;
  }
  .video-name {
    color: #a0a0a0;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  .el-form {
    .el-form-item__label {
      color: #333;
      font-weight: 700;
    }
    .second-title {
      .el-form-item__label {
        font-weight: 400;
      }
    }
  }
}
</style>
<style lang="scss" scoped>
.listHead {
  padding-left: 24px;
  padding-right: 30px;
  width: 100%;
  height: 53px;
  line-height: 53px;
  background-color: #fff;
  margin-top: 10px;
  border-bottom: 1px solid #eee;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.sCircle {
  margin-bottom: 2px;
  margin-right: 10px;
  display: inline-block;
  border: 2px solid #ccc;
  width: 10px;
  height: 10px;
  border-radius: 50%;
}
.btn-box-fixed {
  position: fixed;
  bottom: 10px;
  height: 50px;
  width: 560px;
  background: #fff;
  z-index: 99;
  margin-bottom: 0px !important;
  display: flex;
  justify-content: center;
  align-items: center;
  // border-top: 1px solid #dbdee5;
  .el-button {
    margin-right: 10px;
    width: 100px;
    &.disable-button {
      color: #f3864b;
      border-color: #f3864b !important;
      background: none;
    }
    &.cancel-button {
      color: #2fcf94;
      border-color: #2fcf94;
      background: none;
    }
    &.dilite-button {
      color: #ff5e5e;
      border-color: #ff5e5e;
      border-color: #ff5e5e !important;
      background: none;
    }
  }
}
.catalog-title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    .catalog-name {
        padding: 15px 5px;
        font-size: 15px;
        font-weight: bold;
        color: #666666;
    }
}
.data_body {
  background: #fff;
  display: flex;
  align-items: center;

  flex-wrap: wrap;
  padding-left: 30px;
  .data_item {
    margin: 24px 12px;
    width: 415px;
    height: 188px;
    cursor: pointer;
    background: #f2f4fc;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
      &.un-editable {
          cursor: not-allowed;
      }
    img {
      max-width: 100%;
      max-height: 100%;
    }
    .disableStatus {
      background: rgba(242, 244, 252, 0.5);
      width: 415px;
      height: 188px;
      position: absolute;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
}
.upLod {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.green {
  font-size: 14px;
  color: rgba(243, 134, 75, 1);
}
.video_name {
  font-size: 14px;
  color: rgba(47, 207, 148, 1);
}
.miniImg {
  margin-right: 8px;
  display: flex;
  flex-direction: column;
  // align-items: center;
  // justify-content: center;
  img {
    max-width: 100%;
    max-height: 100%;
  }
  .image-wrapper {
    position: relative;
    width: 172px;
    height: 80px;
    background: rgba(242, 244, 252, 1);
    display: flex;
    align-items: center;
    justify-content: center;
    // display: inline-block;
    // vertical-align: top;
    img {
      max-width: 100%;
      max-height: 100%;
      border-radius: 4px;
    }
    i {
      position: absolute;
      top: -8px;
      right: -8px;
      z-index: 1;
      font-size: 18px;
      color: #999;
      cursor: pointer;
    }
  }
}

.formBody {
  padding: 0 30px;
}
.left_contente {
  padding: 10px 0;
  width: 50%;
  height: 228px;
  overflow-x: hidden;
  overflow-y: scroll;
  text-align: center;
}
.right_contente {
  padding: 10px 0;
  width: 50%;
  height: 228px;
  overflow-x: hidden;
  overflow-y: scroll;
  text-align: center;
  .lin_radio {
    display: flex;
    align-items: start;
    flex-direction: column;
    margin-left: 0%;
    .el-radio {
      margin-bottom: 10px;
    }
  }
}
.media-wrapper {
  display: flex;
  .video-wrapper {
    width: 200px;
  }
  .upload-title {
    color: #505050;
  }
  .image-wrapper {
    position: relative;
    vertical-align: top;
    display: inline-block;
    width: 124px;
    height: 80px;
    border-radius: 4px;
    background: url("../../../../assets/icon/icon_play.png") no-repeat center;
    background-color: #f2f4fc;
    background-size: 20px 20px;
    cursor: pointer;
    i {
      position: absolute;
      top: -8px;
      right: -8px;
      z-index: 1;
      font-size: 18px;
      color: #999;
      cursor: pointer;
    }
  }
  .loading-wrapper {
    position: relative;
    vertical-align: top;
    display: inline-block;
    width: 124px;
    height: 80px;
    line-height: 80px;
    text-align: center;
    border-radius: 4px;
    background-color: #f2f4fc;
    color: #a0a0a0;
    cursor: progress;
  }
  .cover-wrapper {
    .image-wrapper {
      width: 124px;
    }
    img {
      max-width: 124px;
      height: 80px;
      border-radius: 4px;
    }
  }
}
.tree_btm {
  margin-bottom: 10px;
  border: 1px solid #ddd;
  display: flex;

  // background: linear-gradient(white, #ededed);
}
.result {
  border: 1px solid #ddd;
  border-radius: 10px;
  width: 100%;
  height: 120px;
  padding: 10px;
  overflow: auto;
  margin-bottom: 10px;
}
.iptDiv {
  margin-bottom: 10px;
}
.plainBtn {
  border-color: #2ed095 !important;
  color: #2ed095;
    &.is-disabled {
        color: #C0C4CC;
        border-color: #C0C4CC !important;
    }
}
.btns {
  display: flex;
  align-items: center;
  justify-content: center;
}
.flex_row {
  display: flex;
}
.flex_mg {
  margin: 20px 0;
}
.flex_center {
  align-items: center;
}
.row_left {
  width: 66px;
  text-align: right;
  margin-right: 20px;
}
.errtst {
  display: flex;
  justify-content: flex-end;
  position: absolute;
  top: 270px;
  left: 116px;
  span {
    font-size: 12px;
    color: red;
  }
}
.dialogimgdiv{
  width: 100%;
  height: 100%;
  img{
    width: 100%;
    height: 100%;
  }
}
.row_right {
  width: 410px;
  .fg {
    cursor: pointer !important;
  }
}
.flex_column {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  // height: 84px;
}
.red_text {
  color: rgba(244, 108, 108, 1);
}
.modify_text {
  color: rgba(46, 208, 149, 1);
}
</style>
